<template>
  <div>
    <Echart id="centreLeft2Chart" ref="centreLeft4ChartRef" :options="options" height="480px" width="100%"></Echart>
  </div>
</template>

<script>
  import Echart from '@/common/echart';
  export default {
    data() {
      return {
        options: {},
      };
    },
    components: {
      Echart,
    },
    props: {
      cdata: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      cdata: {
        handler(newData) {
          this.options = {
            xAxis: {
              type: 'category',
              data: ['咨询收入', '平台支出', '电商收入', ]
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              data: newData,
              type: 'bar',
              label: {
                show: true,
              }
            }]
          };
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {

    },
  };
</script>